import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import { ZIP_PATTERN, PHONE_PATTERN, NPI_PATTERN, isValidOrBlank } from '../validation/patterns'

export default function FillProviderForm({ visible = false }) {


  const { provider_data, setproviderdata } = useOutletContext()

  var existing_member = false
    if (window.localStorage.getItem('existing_member') == "true") {
        existing_member = true
    } else {
        existing_member = false
    }

  const [firstname, setfirstname] = useState('')
  const [lastname, setlastname] = useState('')
  const [address1, setaddress1] = useState('')
  const [address2, setaddress2] = useState('')
  const [city, setcity] = useState('')
  const [state, setstate] = useState('')
  const [zipcode, setzipcode] = useState('')
  const [phonenumber, setphonenumber] = useState('')
  const [npi, setnpi] = useState('')
  const [isValidZipCode, setIsValidZipCode] = useState(true)
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true)
  const [isValidNpi, setIsValidNpi] = useState(true)

  useEffect(() => {
    if(window.localStorage.getItem('provider_data')){
        setproviderdata(JSON.parse(window.localStorage.getItem('provider_data')))
        setfirstname(provider_data.first_name)
        setlastname(provider_data.last_name)
        setaddress1(provider_data.address.address1)
        setaddress2(provider_data.address.address2)
        setcity(provider_data.address.city)
        setstate(provider_data.address.state)
        setzipcode(provider_data.address.zip_code)
        setphonenumber(provider_data.phones.phone)
        setnpi(provider_data.npi)
    }
}, [])

  function updateFirstName(e) {
    setfirstname(e.target.value)
    provider_data.first_name = e.target.value
    console.log(provider_data)
  }
  function updateLastName(e) {
    setlastname(e.target.value)
    provider_data.last_name = e.target.value
    console.log(provider_data)
  }
  function updateAddress1(e) {
    setaddress1(e.target.value)
    provider_data.address.address1 = e.target.value
    console.log(provider_data)
  }
  function updateAddress2(e) {
    setaddress2(e.target.value)
    provider_data.address.address2 = e.target.value
    console.log(provider_data)
  }
  function updateCity(e) {
    setcity(e.target.value)
    provider_data.address.city = e.target.value
    console.log(provider_data)
  }
  function updateState(e) {
    setstate(e.target.value)
    provider_data.address.state = e.target.value
    console.log(provider_data)
  }
  function updateZipCode(e) {
    setzipcode(e.target.value)
    setIsValidZipCode(isValidOrBlank(ZIP_PATTERN, e.target.value))
    provider_data.address.zip_code = e.target.value
    console.log(provider_data)
  }
  function updatePhoneNumber(e) {
    setphonenumber(e.target.value)
    setIsValidPhoneNumber(isValidOrBlank(PHONE_PATTERN, e.target.value))
    provider_data.phones.phone = e.target.value
    console.log(provider_data)
  }
  function updateNpi(e) {
    setnpi(e.target.value)
    setIsValidNpi(isValidOrBlank(NPI_PATTERN, e.target.value))
    provider_data.npi = e.target.value
    console.log(provider_data)
  }

  return (
    <div id="fill-info" className={visible ? "section" : "section hide"}>
      <div className="search-form-provider form-validate-provider" acceptCharset="utf-8">
        <h2 style={{ fontSize: '1.25em', lineHeight: '1.49em' }}>Fill in the provider's information:</h2>

        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field required-field text">
            <label htmlFor="firstName" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">First name<span className="required">*</span>:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updateFirstName(e)} type="text" id="doc_firstName" className="doc_firstName" name="doc_firstName" value={provider_data.first_name} />
          </p></div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field text">
            <label htmlFor="lastName" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">Last name<span className="required">*</span>:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updateLastName(e)} type="text" id="doc_lastName" className="doc_lastName" name="doc_lastName" value={provider_data.last_name} />
          </p></div>

        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field required-field text">
            <label htmlFor="street" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">Address<span className="required">*</span>:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updateAddress1(e)} type="text" id="doc_address" className="doc_address" name="doc_address" value={provider_data.address.address1} />
          </p></div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field text">
            <label htmlFor="street" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">Address 2:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updateAddress2(e)} type="text" id="doc_address2" className="doc_address2" name="doc_address2" value={provider_data.address.address2} />
          </p></div>
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <p className="field required-field text">
              <label htmlFor="city" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">City<span className="required">*</span>:</span></label>
              <input readOnly={existing_member == true ? true : false} onChange={e => updateCity(e)} type="text" id="doc_city" className="doc_city" name="doc_city" value={provider_data.address.city} />
            </p></div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <p className="field required-field dropdown">
              <label htmlFor="state" style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">State<span className="required">*</span>:</span></label>
              <span className="select_container">
                <select disabled={existing_member == true ? 'disabled' : false} name="doc_state" id="doc_state" className="doc_state" defaultValue="default" value={provider_data.address.state} onChange={e => updateState(e)}>
                  <option label="" value="default">Select a state</option><option label="Alabama" value="AL">Alabama</option><option label="Alaska" value="AK">Alaska</option><option label="American Samoa" value="AS">American Samoa</option><option label="Arizona" value="AZ">Arizona</option><option label="Arkansas" value="AR">Arkansas</option><option label="California" value="CA">California</option><option label="Colorado" value="CO">Colorado</option><option label="Connecticut" value="CT">Connecticut</option><option label="Delaware" value="DE">Delaware</option><option label="Florida" value="FL">Florida</option><option label="Georgia" value="GA">Georgia</option><option label="Guam" value="GU">Guam</option><option label="Hawaii" value="HI">Hawaii</option><option label="Idaho" value="ID">Idaho</option><option label="Illinois" value="IL">Illinois</option><option label="Indiana" value="IN">Indiana</option><option label="Iowa" value="IA">Iowa</option><option label="Kansas" value="KS">Kansas</option><option label="Kentucky" value="KY">Kentucky</option><option label="Louisiana" value="LA">Louisiana</option><option label="Maine" value="ME">Maine</option><option label="Maryland" value="MD">Maryland</option><option label="Massachusetts" value="MA">Massachusetts</option><option label="Michigan" value="MI">Michigan</option><option label="Minnesota" value="MN">Minnesota</option><option label="Mississippi" value="MS">Mississippi</option><option label="Missouri" value="MO">Missouri</option><option label="Montana" value="MT">Montana</option><option label="Nebraska" value="NE">Nebraska</option><option label="Nevada" value="NV">Nevada</option><option label="New Hampshire" value="NH">New Hampshire</option><option label="New Jersey" value="NJ">New Jersey</option><option label="New Mexico" value="NM">New Mexico</option><option label="New York" value="NY">New York</option><option label="North Carolina" value="NC">North Carolina</option><option label="North Dakota" value="ND">North Dakota</option><option label="Northern Mariana Islands" value="NM">Northern Mariana Islands</option><option label="Ohio" value="OH">Ohio</option><option label="Oklahoma" value="OK">Oklahoma</option><option label="Oregon" value="OR">Oregon</option><option label="Pennsylvania" value="PA">Pennsylvania</option><option label="Puerto Rico" value="PR">Puerto Rico</option><option label="Rhode Island" value="RI">Rhode Island</option><option label="South Carolina" value="SC">South Carolina</option><option label="South Dakota" value="SD">South Dakota</option><option label="Tennessee" value="TN">Tennessee</option><option label="Texas" value="TX">Texas</option><option label="U.S. Virgin Islands" value="VI">U.S. Virgin Islands</option><option label="Utah" value="UT">Utah</option><option label="Vermont" value="VT">Vermont</option><option label="Virginia" value="VA">Virginia</option><option label="Washington" value="WA">Washington</option><option label="Washington DC" value="DC">Washington DC</option><option label="West Virginia" value="WV">West Virginia</option><option label="Wisconsin" value="WI">Wisconsin</option><option label="Wyoming" value="WY">Wyoming</option>      </select>
              </span>
            </p></div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field required-field text zipcode">
            <label htmlFor="zipCode" className={!isValidZipCode ? 'red' : ''} style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">ZIP code<span className="required">*</span>:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updateZipCode(e)} onBlur={e => updateZipCode(e)} type="text" id="doc_zipCode" className="doc_zipCode" name="doc_zipCode" maxLength="5" style={isValidZipCode ? {} : { border: '2px solid red' }} value={provider_data.address.zip_code} />
            {!isValidZipCode && (
              <span className="prompt-error error react-error" style={{ padding: 0, margin: 0, display: 'inline', marginBottom: 0 }}>
                Please enter a valid 5-digit ZIP code.
              </span>
            )}
          </p></div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field required-field text">
            <label htmlFor="phone" className={!isValidPhoneNumber ? 'red' : ''} style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">Phone number<span className="required">*</span>:</span></label>
            <input readOnly={existing_member == true ? true : false} onChange={e => updatePhoneNumber(e)} onBlur={e => updatePhoneNumber(e)} type="text" id="doc_phone" className="doc_phone" name="doc_phone" style={isValidPhoneNumber ? {} : { border: '2px solid red' }} value={provider_data.phones.phone} />
            {!isValidPhoneNumber && (
              <span className="prompt-error error react-error" style={{ padding: 0, margin: 0, display: 'inline', marginBottom: 0 }}>
                Please enter a valid 10-digit phone number.
              </span>
            )}
          </p></div>
        <div className="col-sm-12 col-md-12 col-lg-6">
          <p className="field">
            <label htmlFor="doc_npi" className={!isValidNpi ? 'red' : ''} style={{ fontSize: '1em', lineHeight: '1.49em' }}><span className="inner-label">National Provider Identifier (NPI):</span></label>
            <input onChange={e => updateNpi(e)} onBlur={e => updateNpi(e)} type="text" id="doc_npi" className="doc_npi" name="doc_npi" maxLength="10" style={isValidNpi ? {} : { border: '2px solid red' }} value={provider_data.npi} />
            {!isValidNpi && (
              <span className="prompt-error error react-error" style={{ padding: 0, margin: 0, display: 'inline', marginBottom: 0 }}>
                Please enter a valid 10-digit NPI.
              </span>
            )}
          </p></div>
        <input readOnly={existing_member == true ? true : false} type="hidden" className="select_provider" name="select_provider" value="" />
        <input readOnly={existing_member == true ? true : false} type="hidden" className="select_care" name="select_care" value="" />
        <div className="clearfloat"></div>
      </div>
    </div>
  )
}

